export const TELUGU = {
  'language': 'Telugu',
  'amount': {
    'placeholder': 'మీరు ఎంత షెకరించాలని అనుకుంటున్నారు?',
    'error': {
      'min': 'కనీసం ₹2000 వేలు సేకరించాలి!',
      'max': '₹ 5 కోట్ల కంటే ఎక్కువ షెకరించలేరు ',
      'required': 'కనీసం ₹2000 వేలు సేకరించాలి!'
    },
    'hint': 'కనీసం ₹2000 వేలు సేకరించాలి',
    'popover': {
      'title': 'లక్ష్యం',
      // tslint:disable-next-line:max-line-length
      'desc': `మీరు మీ డబ్బుల లక్ష్యం తరువాత ఎప్పుడైనా మార్వచ్చు. ఎక్కడ ప్రారంభించాలో మీకు తెలియకపోతే, చాలా ప్రచారాలకి ₹ 1,00,000 ఏర్పాటు చెయ్యాలి అనే లక్ష్యం ఉంటుంది`,
      'eg': 'లక్ష్యం ₹ 2000 రూపాయాలకన్నా పెద్దదిగా ఉండాలి'
    }
  },
  'title': {
    'placeholder': 'ఫండ్రైసెర్ శీర్షిక',
    'error': {
      'minlength': 'ఫండ్రైసెర్ శీర్షిక 5-75 అక్షరాలా మధ్యలో ఉండాలి',
      'maxlength': 'ఫండ్రైసెర్ శీర్షిక 5-75 అక్షరాలా మధ్యలో ఉండాలి',
      'required': 'ఫండ్రైసెర్ శీర్షిక 5-75 అక్షరాలా మధ్యలో ఉండాలి'
    },
    'popover': {
      'title': 'ఇది మీ ఫండ్రైసెర్ శీర్షిక',
      'desc': 'ఉదాహరణ: నిరుపేద ఆడపిల్లలను శక్తివంతం చేయడంలో నాకు సహాయపడండి లేదా మా ఆస్తా క్యాన్సర్ పోరాడటానికి సహాయం చెయ్యండి!'
    },
    'medicalDocTitle': 'వైద్య పత్రాలను అప్లోడ్ చెయ్యండి'
  },
  'relation': {
    'placeholder': 'ఎవరికోసం డబ్బులు ఏర్పాటు చేస్తున్నారు?',
    'popover': {
      'title': 'ఎవరికోసం డబ్బులు ఏర్పాటు చేస్తున్నారు',
      'desc': 'ఉదాహరణ: మీరు వ్యక్తిగత, సృజనాత్మక, లేదా NGO కోసం ప్రచారం సృష్టించవచ్చు'
    },
    'error': {
      'required': 'దయచేసి చెల్లుబాటు అయినా ఎంపికను ఎంచుకోండి'
    }
  },
  'name': {
    'placeholder': `పేషెంట్ పూర్తి పేరు `,
    'error': {
      'maxlength': 'పేరు 50 అక్షరాలకన్నా ఎక్కువ ఉండకూడదు',
      'pattern': 'దయచేసి సరైన పేరు పెట్టండి',
      'required': 'దయచేసి సరైన పేరు పెట్టండి'
    },
    'hint': 'పేషెంట్ ఆధార్ కార్డు మీద ఉన్న పేరు',
    'popover': {
      'title': `పేషెంట్ పేరు `,
      'desc': 'దయచేసి పేషెంట్ ఆధార్ కార్డు మీద ఉన్నటు పేరు రాయండి'
    }
  },
  'patient': {
    'placeholder': `పేషెంట్ పూర్తి పేరు`,
    'error': {
      'maxlength': 'పేరు 50 అక్షరాలకన్నా ఎక్కువ ఉండకూడదు ',
      'minlength': 'దయచేసి పేషెంట్ ఆధార్ కార్డు మీద ఉన్నటు తన పూర్తి పేరు రాయండి',
      'pattern': 'దయచేసి సరైన పేరు పెట్టండి',
      'required': 'దయచేసి సరైన పేరు పెట్టండి'
    },
    'hint': 'పేషెంట్ ఆధార్ కార్డు మీద ఉన్న పేరు',
    'popover': {
      'title': `పేషెంట్ పేరు`,
      'desc': 'దయచేసి పేషెంట్ ఆధార్ కార్డు మీద ఉన్నటు పేరు రాయండి'
    }
  },
  'age': {
    'placeholder': `పేషెంట్ వయసు`,
    'error': {
      'required': 'దయచేసిసరైన వయస్సు సమూహాన్ని రాయండి'
    }
  },
  'hosptialisationStatus': {
    'placeholder': `హాస్పిటలైజేషన్ స్థితి`,
    'error': {
      'required': 'సమాధానం అవసరం'
    }
  },
  'cause': {
    'placeholder': 'దయచేసి కారణాన్ని ఎంచుకోండి',
    'popover': {
      'title': 'ఇది మీ కారణం ',
      'desc': 'ఇది మా వెబ్‌సైట్‌లో మీ డబ్బుల సేకరణని దయగల, ఒకటిగా ఆలోచించే వ్యక్తులకి కనుక్కోవడంలో సహాయం చేయడం కోసం.'
    },
    'error': {
      'required': 'దయచేసి కారణాన్ని ఎంచుకోండి'
    }
  },
  'end_date': {
    'placeholder': 'ముగింపు తేది',
    'error': {
      'minlength': 'డబ్బుల సేకరణ ముగింపు తేదీ ఈరోజు కంటే పాతది కాకూడదు!',
    },
    'popover': {
      'title': 'డబ్బుల సేకరణ ముగింపు తేదీ',
      'desc': 'మీ డబ్బుల సేకరణ ఈ రోజు ముగిస్తుంది'
    }
  },
  'fundraiser_image': {
    'placeholder': 'ఫండ్రైసెర్ ఫోటోని/వీడియోని ఇక్కడ అప్లోడ్ చెయ్యండి',
    'optional': '(ఉంటే)',
    'upload': 'అప్లోడ్',
    'popover': {
      'title': 'ఫండ్రైసెర్ ఫోటోని/వీడియోని అప్లోడ్ చెయ్యండి',
      'desc': `ఇది మీ ఫండ్రైజర్యోక్క యొక్క మొదటి పేజీ. మంచి ఫోటోలు మీకు ఎక్కువ డబ్బు సంపాదించడానికి సహాయపడతాయి. మీ ఫండ్రైజెర్ ఉత్తమంగా వివరించే దాపరికం ఫోటోలను/వీడియోలను అప్‌లోడ్ చేయండి.`,
      'eg': `ఆదర్శ పరిమాణం: 750x435 px. ఫోటో పెద్దది అయితే, చింతించకండి, అప్‌లోడ్ చేసేటప్పుడు మీరు దాన్ని చిన్నదిగా చేయవచ్చు.`
    }
  },
  'beneficiary_image': {
    'placeholder': `పేషెంట్ ఫోటోని పెట్టండి `,
    'popover': {
      'title': 'ఎవరికోసమైతే మీరు డబ్బులు సేకరిస్తున్నారో, వారే వీరు ',
      'desc': `"ఇమేజ్‌ని పెడితే విరాళాలు 50% పెరుగుతాయి.
            సేకరించిన నిధులు ఈ లబ్ధిదారుడికి వెళ్తాయని ధృవీకరించడానికి మేము మీ నించి అదనపు సమాచారాన్ని అభ్యర్థించవచ్చు."`
    }
  },
  'short_description': {
    'placeholder': 'లాఘువంగా వివరించండి',
    'error': {
      'minlength': 'కనీసం 10 అక్షరాలూ అవసరం',
      'maxlength': 'వివరణ 120 అక్షరాలను మించకూడదు'
    },
    'popover': {
      'title': 'లాఘువంగా వివరించండి',
      'desc': `లాఘువంగా 120 అక్షరాల్లో మీ ఫండ్రైజెర్ గురించి వివరించండి `,
      'eg': `ఉదాహరణ: ఆస్తాకు కేవలం 8 సంవత్సరాలు, తీవ్రమైన లింఫోబ్లాస్టిక్ లుకేమియాకు వ్యతిరేకంగా ఆమె పోరాటానికి సహాయం చెయ్యండి`
    }
  },
  'description_story': {
    'placeholder':
      'మీ అవసరానికి న్యాయం చేసేదేకాకుండా, చూసేవాళ్ళు సహాయం బటన్ని క్లిక్ చేసే కథను రాయండి'
      + '\n\nఈ దశలను అనుసరించండి:'
      + '\n* ఎవరికోసం డబ్బులు ఏర్పాటు చేస్తున్నారో వాళ్ళగురించి చెప్పండి, అది మీకోసమే ఐన లేకపోతే మీకీ ప్రియమైన వాళ్ళ కోసమైనా'
      + '\n* డబ్బులు ఎందుకు సేకరిస్తున్నారో వివరించండి'
      + '\n* మీ మద్దతుదారులకు విజ్ఞ్యాపించండి',
    'popover': {
      'title': 'మీ ఫండ్రైసెర్ గురించి మాకు ఇంకా చెప్పండి',
      'desc': 'మీ కథ చెప్పండి ',
      'placeholder':
        `<div>• మీ అవసరానికి న్యాయం చేసేదేకాకుండా, చూసేవాళ్ళు సహాయం బటన్ని క్లిక్ చేసే కథను రాయండి</div>
            <div>• మీరు మీ కథ రాసేటప్పుడు చిక్కుకుంటే, నిరాశ పడకండి.</div>
            <div>• కింద ఉన్న దశలను అనుసరించండి:</div>
            <div>• ఎవరికోసం డబ్బులు ఏర్పాటు చేస్తున్నారో వాళ్ళగురించి చెప్పండి, అది మీకోసమే ఐన లేకపోతే మీకు ప్రియమైన వాళ్ళ కోసమైనా </div>
            <div>• డబ్బులు ఎందుకు సేకరిస్తున్నారో వివరించండి</div>
            <div>• మీ మద్దతుదారులకు విజ్ఞ్యాపించండి</div>
            <div>• ఈ ఫండ్రైసర్ ఎందుకు మొదలుపెట్టారో మీ మద్దతుదారులకు చెప్పండి, తద్వారా వారు సహాయపడడానికి ఎక్కువ ఆతృతగా  వుంటారు.</div>
            <div>• మీ వివరాలన్నీ రాయండి, తద్వారా మీ మద్దతుదారులకి వారి డబ్బు ఎక్కడికి వెళ్తుందో తెలిసేందుకు</div>
            <div>• వర్డ్ డాక్యుమెంట్ నించి వివరాలు కాపీ పేస్ట్ చెయ్యకుండా చూసుకోండి.</div>`,
    }
  },
  'disease': {
    'label': 'వ్యాది పేరు ',
    'placeholder': 'మీ వ్యాధి పేరుని ఇక్కడ రాయండి',
    'error': {
      'required': 'దయచేసి ఒక వ్యాధిని ఎంచుకోండి'
    }
  },
  'hospital': {
    'label': 'ఆసుపత్రి',
    'placeholder': 'ఇక్కడ మీ ఆసుపత్రి పేరు రాయండి',
    'error': {
      'required': 'దయచేసి ఒక ఆసుపత్రిని ఎంచుకోండి'
    }
  },
  'cover_image': {
    'title': 'కవర్ చిత్రం అప్‌లోడ్ చేయండి',
    'desc': `<ul>
    <li>ఇది మీ ఫండ్రైజర్‌కు ముఖం అవుతుంది. మంచి ఫోటోలు మీ ఫండ్రైజర్‌కు ఎక్కువ నిధులు సమీకరించడంలో సహాయపడతాయి.</li>
    <li>మీ ఫండ్రైజర్‌ను ఉత్తమంగా వివరించే నాణ్యత గల, హై రిజల్యూషన్ చిత్రాలు/వీడియోలు జోడించండి.</li>
    <li>ఆదర్శ పరిమాణం: 750x435. ఇది పెద్దదిగా ఉంటే, మీరు అప్‌లోడ్ చేస్తూ ఉండగానే క్రాప్ చేయవచ్చు.</li>
    <li>ప్రభుత్వ నిబంధనలు మరియు ప్లాట్‌ఫాం పాలన ప్రకారం పిల్లల చిత్రాలు మసకబారేలా చేయబడతాయి.</li>
  </ul>`,
    'see_egs': 'ఉదాహరణలు చూడండి'
  },
  'medicalPopoverContent': {
    'title': 'పత్రం(ల) పై కింద వున్నయన్నీ స్పష్టానంగా చదవగలిగేలా ఉండాలి:',
    'desc': `
        <ol>
            <li>మొత్తం చికిత్స ఖర్చు, పేషెంట్ పేరు, ఆసుపత్రి పేరు, డాక్టర్ పేరు, వ్యాధి, లేఖ తేదీ</li>
            <li>పత్రం(ల) పై వున్నా పై వివరాలన్నీ ఫండ్రైసర్లో పెట్టిన వివరాలతో సరిపోవాలి.</li>
            <li>పత్రం(ల) పై వున్నా మొత్తం చికిత్స ఖర్చు ఫండ్రైసర్లో రాసిన లక్షణానికి సరిపోవాలి</li>
            <li>పత్రం(లు) అప్లోడ్ చేసిన తేదీ నించి 6 నెలల కంటే పాతదిగా ఉండకూడదు</li>
            <li>పత్రం(లు) చేతితో రాసిన సందర్భంలో, దాని(వాటి) పై తప్పనిసరిగా డాక్టర్/ఆసుపత్రి స్టాంప్ ఉండాలి</li>
        </ol>`,
    'see_egs': '',
    'hint_medical_file': '*సులభంగా ఆమోదం పొందటానికి అప్లోడ్ చేసిన పత్రాలలో చికిత్స ఖర్చు మరియు ఫండ్రైసర్ లక్ష్యం అనుగుణంగా ఉన్నాయని దయచేసి నిర్ధారించుకోండి. సమర్పించే ముందు అన్ని పత్రాలను పరిశీలించుకోండి.'
  },
  'sample_images': {
    'title': 'ఈ ఉదాహరణలను ప్రయత్నించండి',
    'got_it': 'అర్థమయ్యింది'
  },
  'guardian_relations': {
    'Friend': {
      'Below 5 years': 'గార్డియన్  నెంబర్ అవసరం',
      '6 -10 years': 'గార్డియన్  నెంబర్ అవసరం',
      '11 - 17 years': 'గార్డియన్  నెంబర్ అవసరం',
      '18 - 30 years': 'పేషెంట్ నెంబర్ అవసరం',
      '30 - 40 years': 'పేషెంట్ నెంబర్ అవసరం',
      'Above 40 years': 'పేషెంట్ నెంబర్ అవసరం'
    },
    'Friend\'s Family': {
      'Below 5 years': 'గార్డియన్  నెంబర్ అవసరం',
      '6 -10 years': 'గార్డియన్  నెంబర్ అవసరం',
      '11 - 17 years': 'గార్డియన్  నెంబర్ అవసరం',
      '18 - 30 years': 'పేషెంట్ నెంబర్ అవసరం',
      '30 - 40 years': 'పేషెంట్ నెంబర్ అవసరం',
      'Above 40 years': 'పేషెంట్ నెంబర్ అవసరం'
    },
    'Colleague': {
      'Below 5 years': 'గార్డియన్  నెంబర్ అవసరం',
      '6 -10 years': 'గార్డియన్  నెంబర్ అవసరం',
      '11 - 17 years': 'గార్డియన్  నెంబర్ అవసరం',
      '18 - 30 years': 'పేషెంట్ నెంబర్ అవసరం',
      '30 - 40 years': 'పేషెంట్ నెంబర్ అవసరం',
      'Above 40 years': 'పేషెంట్ నెంబర్ అవసరం'
    },
    'Relative': {
      'Below 5 years': 'గార్డియన్  నెంబర్ అవసరం',
      '6 -10 years': 'గార్డియన్  నెంబర్ అవసరం',
      '11 - 17 years': 'గార్డియన్  నెంబర్ అవసరం',
      '18 - 30 years': 'పేషెంట్ నెంబర్ అవసరం',
      '30 - 40 years': 'పేషెంట్ నెంబర్ అవసరం',
      'Above 40 years': 'పేషెంట్ నెంబర్ అవసరం'
    },
    'Legal ward': {
      '18 - 30 years': 'పేషెంట్ నెంబర్ అవసరం',
      '30 - 40 years': 'పేషెంట్ నెంబర్ అవసరం',
      'Above 40 years': 'పేషెంట్ నెంబర్ అవసరం'
    }
  },
  'survey': {
    'placeholder': 'మా గురించి మీరు ఎలా తెలుసుకున్నారు?',
    'error': {
      'required': 'సమాధానం అవసరం'
    }
  },
  change_easily: 'మీరు ఎప్పుడైనా మీ ఫండ్రైస్ర్కీ  సులభంగా మార్పులు చేయవచ్చు',
  tell_us_more: 'మీ ఫండ్రైసెర్ గురించి మాకు ఇంకా చెప్పండి',
  patientIsMy: 'పేషెంట్ నా... ',
  qualification: 'మీ విద్యా అర్హత',
  occupation: 'మీ ఉద్యోగ స్థితి',
  raising_funds_for: 'డబ్బులు సేకరణ చేసే కారణం',
  ngo_charity: 'ఎన్జీఓ/దాతృత్వం',
  purposeText: 'ప్రయోజనం',
  other: 'ఇతర',
  medicalTreatment: 'వైద్య చికిత్స',
  iAgree: 'నేను కెట్టోకి అంగీకరిస్తున్నాను',
  serviceAgreement: 'సేవ ఒప్పందం',
  and: 'మరియు',
  change_purpose: 'కారణం మార్చాలా',
  save_and_continue: 'సేవ్ చేసి కొనసాగించండి',
  ketto_zero_fee: 'కెట్టొ  యొక్క జీరో ప్లాట్ఫార్మ్ ఫీజు పాలసీ మీకు ఎక్కువ డబ్బులు దక్కేటట్టు చూస్తుంది ',
  is_patient_admitted: 'పేషెంటుని ఆస్పత్రిలో చేర్పించారా?',
  tell_us_about_patient: `పేషెంట్ గురించి చెప్పండి`,
  medical_condition: `వ్యాది పేరు `,
  guardian_no: `గార్డియన్ మొబైల్ నంబర్`,
  patient_no: 'పేషెంట్ మొబైల్ నంబర్',
  yes: `అవును `,
  no: `లేదు`,
  story_form_title: `మీరు డబ్బులు ఎందుకు సేకరిస్తున్నారో చెప్పండి`,
  help_me_write_this: `ఇది రాయడానికి నాకు సహాయం చెయ్యండి`,
  terms_of_use: `ఉపయోగ నిబంధనలు`,
  privacy_policy: `గోప్యతా పాలసీలు`,
  plans_and_pricing: `ప్రణాళికలు & ధరలను`,
  submit: 'సమర్పించండి',
  get_assistance: 'సహాయం పొందండి',
  selectOption: 'లిస్టు నించి ఒక ఆప్షన్ని ఎంచుకోండి',
  validPhNo: 'దయచేసి చెల్లుబాటు అయ్యే నంబర్‌ను నమోదు చేయండి ',
  back: 'వెనకాలకి',
  fieldRequired: 'సమాధానం అవసరం',
  medicalDocTitle: 'వైద్య పత్రాలను అప్లోడ్ చెయ్యండి',
  acknowledge: 'పైన ఇచ్చిన సమాచారం నా జ్ఞానం మరియు నమ్మకానికి సరైనదని నేను గుర్తించాను మరియు ధృవీకరిస్తున్నాను. తప్పు అని తేలితే నేను బాధ్యత వహించాలని అంగీకరిస్తున్నాను. రెగ్యులేటరీ అధికారులతో భాగస్వామ్యం చేయడానికి లేదా చట్టం ప్రకారం అవసరమయ్యే విధంగా బహిర్గతం చేయడానికి నేను దీని ద్వారా నా సమ్మతిని ఇస్తున్నాను.',
  city: {
    placeholder: 'మీ నగరం పేరు రాయండి',
    popover: {
      title: 'మీ ఫండ్రైజెర్ నగరం పేరు రాయండి',
      desc: 'ఈ ఫండ్రైజెర్ నడుస్తున్న నగరం ఇది..'
    }
  },
  'uploadImg': {
    'error': {
      'required': 'సమాధానం అవసరం',
      'pattern': 'దయచేసి చెల్లుబాటు అయ్యే నంబర్‌ను నమోదు చేయండి'
    }
  },
  skipStepInfo: 'ఏం పర్వాలేదు! మీరు ప్రస్తుతానికి కథ వివరాలు మరియు ఆసుపత్రి పత్రికలూ లేకుండానే సమర్పించి ఇవ్వి తర్వాత జోడించవచ్చు'
};
